<template>
  <div>
    <!--Stats cards-->
    <div class="row">
      <div class="col-lg-3 col-md-6 col-sm-6" v-for="stats in statsCards">
        <stats-card
          :type="stats.type"
          :icon="stats.icon"
          :small-title="stats.title"
          :title="stats.value"
        >
          <div class="stats" slot="footer">
            <i :class="stats.footerIcon"></i>
            {{stats.footerText}}
          </div>
        </stats-card>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-sm-6">
        <chart-card
          v-if="salesByDay7DaysChart.data"
          :chart-data="salesByDay7DaysChart.data"
          chart-title="Total fares in past 7 days"
          :chart-options="{ title: { display: true, text: 'Total fares in past 7 days' } }"
        >
          <span slot="title">{{ salesByDay7DaysChart.meta.summary }}</span>
          <badge slot="title-label" type="success">{{ salesByDay7DaysChart.meta.change }}</badge>

          <template slot="footer-title">
            <router-link to="/account/sales" class="text-success">
              View fares data
              <span class="pull-right">
                <i class="fa fa-chevron-right"></i>
              </span>
            </router-link>
          </template>
        </chart-card>
      </div>

      <div class="col-lg-4 col-sm-6">
        <chart-card
          v-if="salesByDay30DaysChart.data"
          :chart-data="salesByDay30DaysChart.data"
          color="#ef8156"
          chart-title="Total fares in past 30 days"
          :chart-options="{ title: { display: true, text: 'Total fares in past 30 days' } }"
        >
          <span slot="title">{{ salesByDay30DaysChart.meta.summary }}</span>
          <badge slot="title-label" type="danger">{{ salesByDay30DaysChart.meta.change }}</badge>

          <template slot="footer-title">
            <router-link to="/account/sales" class="text-danger">
              View fares data
              <span class="pull-right">
                <i class="fa fa-chevron-right"></i>
              </span>
            </router-link>
          </template>
        </chart-card>
      </div>

      <div class="col-lg-4 col-sm-6">
        <chart-card
          v-if="salesByCardScheme30DaysChart.data"
          :chart-data="salesByCardScheme30DaysChart.data"
          chart-type="Doughnut"
          color="#fbc658"
          chart-title="Card schemes (past 30 days)"
          :title-label="null"
          :chart-options="{  title: { display: true, text: 'Card schemes (past 30 days)' }, legend: { display: true, position: 'bottom' }, tooltips: { enabled: true } }"
        >
          <span slot="title">{{ salesByCardScheme30DaysChart.meta.summary }}</span>

          <template slot="footer-title">
            <router-link to="/account/sales" class="text-warning">
              View more details
              <span class="pull-right">
                <i class="fa fa-chevron-right"></i>
              </span>
            </router-link>
          </template>
        </chart-card>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Best and worst-performing drivers</h4>
            <p class="card-category">Active drivers in past 30 days (by fare value)</p>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-5">
                <h6>Best-performing</h6>
                <div class="table-responsive" style="overflow: auto !important;">
                  <table class="table" v-if="driversSummary.best.length">
                    <tbody>
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th class="text-right">Fares</th>
                        <th class="text-right">Value</th>
                      </tr>
                      <tr v-for="driver in driversSummary.best" v-bind:key="driver.id">
                        <td>{{ driver.rank }}</td>
                        <td>
                          <router-link :to="`/account/drivers/${driver.id}`">{{ driver.name }}</router-link>
                        </td>
                        <td class="text-right">{{ driver.performance30Days.salesCount }}</td>
                        <td class="text-right">{{ driver.performance30Days.salesValue }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="col-md-5 offset-md-1">
                <h6>Worst-performing</h6>
                <div class="table-responsive" style="overflow: auto !important;">
                  <table class="table" v-if="driversSummary.worst.length">
                    <tbody>
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th class="text-right">Fares</th>
                        <th class="text-right">Value</th>
                      </tr>
                      <tr v-for="driver in driversSummary.worst" v-bind:key="driver.id">
                        <td>{{ driver.rank }}</td>
                        <td>
                          <router-link :to="`/account/drivers/${driver.id}`">{{ driver.name }}</router-link>
                        </td>
                        <td class="text-right">{{ driver.performance30Days.salesCount }}</td>
                        <td class="text-right">{{ driver.performance30Days.salesValue }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import accounting from "accounting";
import moment from "moment";
import _ from "lodash";
import CircleChartCard from "src/components/UIComponents/Cards/CircleChartCard.vue";
import ChartCard from "src/components/UIComponents/Cards/ChartCard";
import StatsCard from "src/components/UIComponents/Cards/StatsCard";
import { Badge } from "src/components/UIComponents";
import Loading from "src/components/Dashboard/Layout/LoadingMainPanel.vue";
import TaskList from "./Widgets/TaskList";
const WorldMap = () => ({
  component: import("./../Maps/WorldMap.vue"),
  loading: Loading,
  delay: 200
});

export default {
  components: {
    StatsCard,
    ChartCard,
    CircleChartCard,
    WorldMap,
    Badge,
    TaskList
  },
  /**
   * Chart data used to render stats, charts. Should be replaced with server data
   */
  data() {
    return {
      loading: false,
      statsCards: [],
      salesByDay7DaysChart: {
        data: null,
        meta: {
          summary: null,
          change: null
        }
      },
      salesByDay30DaysChart: {
        data: null,
        meta: {
          summary: null,
          change: null
        }
      },
      salesByCardScheme30DaysChart: {
        data: null,
        meta: {
          summary: null,
          change: null
        }
      },
      driversSummary: {
        best: [],
        worst: []
      }
    };
  },
  beforeMount() {
    this.loading = true;

    const driversQuery =
      "/v1/drivers/?isActive=true&_sort=performance30Days.salesValue&_limit=10";
    this.axios
      .get(`${driversQuery}&_order=desc`)
      .then(response => {
        this.driversSummary.best = _.map(response.data, (item, index) => {
          item.rank = index + 1;
          item.performance30Days.salesValue = `${accounting.formatMoney(
            item.performance30Days.salesValue / 100,
            "£",
            0
          )}`;
          return item;
        });

        return this.axios.get(`${driversQuery}&_order=asc`);
      })
      .then(response => {
        const totalCount = parseInt(response.headers["x-total-count"]);
        this.driversSummary.worst = _.map(response.data, (item, index) => {
          item.rank = totalCount - index;
          item.performance30Days.salesValue = `${accounting.formatMoney(
            item.performance30Days.salesValue / 100,
            "£",
            0
          )}`;
          return item;
        });
      })
      .catch(error => {
        this.loadingError = "Failed to load drivers";
      });

    this.axios
      .get("/v1/overview")
      .then(response => {
        // set the data up
        this.statsCards.push({
          type: "warning",
          icon: "fa fa-users",
          title: "Drivers",
          value: `${response.data.drivers.active}`,
          footerText: `${response.data.drivers.inactive} inactive`,
          footerIcon: "fa fa-user-secret"
        });

        this.statsCards.push({
          type: "success",
          icon: "fa fa-hand-paper-o",
          title: "Fares",
          value: `${accounting.formatMoney(
            response.data.sales.salesValue7Days / 100,
            "£",
            0
          )}`,
          footerText: "Last 7 days",
          footerIcon: "fa fa-calendar-o"
        });

        this.statsCards.push({
          type: "danger",
          icon: "fa fa-calculator",
          title: "Terminals",
          value: `${response.data.terminals.allocated}`,
          footerText: `${response.data.terminals.unallocated} unallocated`,
          footerIcon: "fa fa-cubes"
        });

        this.statsCards.push({
          type: "info",
          icon: "nc-icon nc-favourite-28",
          title: "Active",
          value: `${response.data.terminals.activeCount}`,
          footerText: "Online in last hour",
          footerIcon: "fa fa-clock-o"
        });

        this.salesByDay7DaysChart = {
          data: {
            labels: _.map(response.data.sales.salesByDay7Days, item => {
              return moment(item.date).format("DD MMM");
            }),
            series: _.map(response.data.sales.salesByDay7Days, item => {
              return item.value / 100;
            })
          },
          meta: {
            summary: `${accounting.formatMoney(
              response.data.sales.salesValue7Days / 100,
              "£",
              0
            )}`,
            change: response.data.sales.salesValue7DaysChange
          }
        };

        this.salesByDay30DaysChart = {
          data: {
            labels: _.map(response.data.sales.salesByDay30Days, item => {
              return moment(item.date).format("DD MMM");
            }),
            series: _.map(response.data.sales.salesByDay30Days, item => {
              return item.value / 100;
            })
          },
          meta: {
            summary: `${accounting.formatMoney(
              response.data.sales.salesValue30Days / 100,
              "£",
              0
            )}`,
            change: response.data.sales.salesValue30DaysChange
          }
        };

        // salesByCardScheme30Days
        this.salesByCardScheme30DaysChart = {
          data: {
            datasets: [
              {
                data: [
                  response.data.sales.salesByCardScheme30Days.visa,
                  response.data.sales.salesByCardScheme30Days.mastercard,
                  response.data.sales.salesByCardScheme30Days.american_express
                ],
                backgroundColor: ["#1D2966", "#FE5D22", "#0372CA"],
                hoverBackgroundColor: ["#374ec3", "#ca3701", "#acdafe"]
              }
            ],
            labels: ["Visa", "Mastercard", "American Express"]
          },
          meta: {
            summary: `${accounting.formatMoney(
              response.data.sales.salesCount30Days,
              "",
              0
            )} fares`
          }
        };

        this.loading = false;
      })
      .catch(error => {
        this.loading = false;
        this.loadingError = "Failed to load overview";
      });
  }
};
</script>
<style>
</style>
